import PropTypes from 'prop-types';

/**
 * Dashboard
 * @param {*} props
 */

const DashboardContainer = (props) => {
  const {children} = props;
  return <div>{children}</div>;
};

DashboardContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element])
};

export default DashboardContainer;
